import { createSelector } from 'reselect'
import combineReducers from 'store/ReducerConfig'

export const selectFileState = (state: ReturnType<typeof combineReducers>) => {
  return state.file
}

export const selectFileNew = createSelector([selectFileState], ({ fileNew }) => fileNew || [])
